import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { useTopIssues } from './hooks/useTopIssues';

export const TopIssues: React.FC = () => {
	const {
		data: { issues },
	} = useTopIssues();

	if (issues.length === 0) return null;

	return <TopIssuesContent />;
};

const TopIssuesContent: React.FC = () => {
	const {
		data: { displayName, issues },
	} = useTopIssues();

	return (
		<div className="flex flex-col gap-4 px-4 pb-8 md:px-0" data-testid="dm-top-issues-container">
			<Text variant="heading">Where {displayName} stands on these issues</Text>

			<ul className="flex flex-col gap-5">
				{issues.map((issue) => (
					<li className="flex flex-col gap-2" key={`Issue_${issue.issueId}`}>
						<Text fontWeight="bold">
							{issue.graphic} {issue.title}
						</Text>

						<ul className="ml-2 flex list-outside list-disc flex-col gap-1">
							{issue.stances.map((stance) => (
								<li key={`Issue_${issue.issueId}_Stance_${stance}`} className="text-typography-strong ml-2.5">
									<Text size="small" className="text-typography-strong">
										{stance}
									</Text>
								</li>
							))}
						</ul>
					</li>
				))}
			</ul>
		</div>
	);
};
